import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-navy py-8 text-center text-cream/40 text-sm" data-id="element-24">
        <div className="max-w-7xl mx-auto px-6" data-id="element-25">
          <p data-id="element-26">
            © {new Date().getFullYear()} Huesos Invencibles. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs max-w-2xl mx-auto" data-id="element-27">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier programa de ejercicios.
          </p>
          <div className="mt-4 flex items-center justify-center gap-4" data-id="element-28">
            <button onClick={() => setShowPrivacy(true)} className="text-cream/50 hover:text-teal transition-colors underline underline-offset-2" data-id="element-29">
              Política de Privacidad
            </button>
            <span className="text-cream/20" data-id="element-30">|</span>
            <button onClick={() => setShowTerms(true)} className="text-cream/50 hover:text-teal transition-colors underline underline-offset-2" data-id="element-31">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-32">
        <p data-id="element-33">
          <strong data-id="element-34">Última actualización:</strong> Marzo 2026
        </p>
        <p data-id="element-35">
          En Huesos Invencibles, respetamos y protegemos tu privacidad. Esta
          política describe cómo recopilamos, usamos y protegemos tu información
          personal cuando adquieres nuestros productos digitales.
        </p>
        <h3 className="font-serif font-bold text-navy text-lg pt-2" data-id="element-36">
          Información que recopilamos
        </h3>
        <p data-id="element-37">
          Únicamente recopilamos la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos datos de tarjetas de crédito; estos son procesados de
          forma segura por nuestro proveedor de pagos.
        </p>
        <h3 className="font-serif font-bold text-navy text-lg pt-2" data-id="element-38">
          Uso de la información
        </h3>
        <p data-id="element-39">
          Tu información se utiliza exclusivamente para: entregar el producto
          digital adquirido a tu correo electrónico y enviarte comunicaciones
          relacionadas con tu compra. No compartimos, vendemos ni cedemos tu
          información personal a terceros.
        </p>
        <h3 className="font-serif font-bold text-navy text-lg pt-2" data-id="element-40">
          Protección de datos
        </h3>
        <p data-id="element-41">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
        <h3 className="font-serif font-bold text-navy text-lg pt-2" data-id="element-42">
          Tus derechos
        </h3>
        <p data-id="element-43">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento. El acceso al producto digital descargado no se verá afectado,
          ya que una vez descargado es tuyo permanentemente.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-44">
        <p data-id="element-45">
          <strong data-id="element-46">Última actualización:</strong> Marzo 2026
        </p>
        <p data-id="element-47">
          Al adquirir el producto digital "Huesos Invencibles", aceptas los
          siguientes términos y condiciones de uso.
        </p>
        <h3 className="font-serif font-bold text-navy text-lg pt-2" data-id="element-48">
          Producto digital
        </h3>
        <p data-id="element-49">
          "Huesos Invencibles" es una guía digital informativa en formato
          descargable. Una vez completada la compra, recibirás acceso inmediato
          al material a través de tu correo electrónico. El producto es tuyo de
          forma permanente.
        </p>
        <h3 className="font-serif font-bold text-navy text-lg pt-2" data-id="element-50">
          Uso personal
        </h3>
        <p data-id="element-51">
          El contenido adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución o reventa total o
          parcial del material sin autorización expresa.
        </p>
        <h3 className="font-serif font-bold text-navy text-lg pt-2" data-id="element-52">
          Descargo de responsabilidad médica
        </h3>
        <p data-id="element-53">
          Este producto tiene fines informativos y educativos. No sustituye el
          diagnóstico, tratamiento ni consejo de un profesional médico
          cualificado. Consulta siempre a tu médico antes de iniciar cualquier
          programa de ejercicios o cambios en tu alimentación, especialmente si
          tienes condiciones de salud preexistentes.
        </p>
        <h3 className="font-serif font-bold text-navy text-lg pt-2" data-id="element-54">
          Política de reembolso
        </h3>
        <p data-id="element-55">
          Debido a la naturaleza digital del producto, no se ofrecen reembolsos
          una vez realizada la descarga. Si experimentas problemas técnicos con
          la descarga, nos comprometemos a resolverlos para garantizar que
          recibas tu producto.
        </p>
      </Modal>
    </>;
}